<template>
  <el-table-column label="操作" :fixed="fixed" :width="width" align="center">
    <template slot-scope="scope">
      <div class="action-col">
        <el-link
          v-for="item in (isFunctional ? actions(scope.row, scope.$index) : actions)"
          :key="item.label"
          :underline="false"
          :type="item.type"
          class="action-btn"
          @click="handleClick(item.action, scope.row, scope.$index)"
        >
          {{ item.label }}
        </el-link>
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  props: {
    actions: {
      type: [Array, Function],
      default: () => []
    },
    width: {
      type: Number,
      default: 100
    },
    fixed: {
      type: String,
      default: 'left'
    },
    table: Object
  },
  computed: {
    isFunctional () {
      return Object.prototype.toString.call(this.actions) === '[object Function]'
    }
  },
  methods: {
    handleClick (fn, row, index) {
      return fn.call(this.table, row, index)
    }
  }
}
</script>

<style lang="less">
.action-col {
  // display: flex;
  // padding: 0 8px;
  // flex-direction: row;
  // flex-wrap: nowrap;
  // justify-content: space-around;

  .we-link--inner {
    font-weight: 400;
  }
}

.action-btn {
  margin: 0 4px;
}
</style>
